import { PRIVACY_POLICY_URL } from "@/data/constants/policy-links";
import { DEFAULT_LANGUAGE, getSelectedLanguageCode } from "@/utils/language-util";

/**
 * 개인정보 처리방침 URL을 가져오는 usecase
 */
export class GetPrivacyPolicyUrlUsecase {
  /**
   * 사용자가 선택한 언어에 따라 개인정보 처리방침 페이지 URL을 반환합니다.
   * @returns 개인정보 처리방침 페이지 URL
   */
  execute(): string {
    // 지원하지 않는 언어는 한국어 기본값 사용
    return PRIVACY_POLICY_URL[getSelectedLanguageCode()] ?? PRIVACY_POLICY_URL[DEFAULT_LANGUAGE];
  }
}
